<template>
    <div class="settings-index">
            <div class="account">
                <div class="grid">
                        <div class="field-group">
                            <label>{{ $page.props.lang.name || "Name" }}</label>
                            <v-text-field v-model="toReturn.name"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.name" @focus="responseErrors.name=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.city || "City" }}</label>
                            <v-text-field v-model="toReturn.city"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.city" @focus="responseErrors.city=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.email || "Email" }}</label>
                            <v-text-field v-model="toReturn.email"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.email" @focus="responseErrors.email=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.address || "Address" }}</label>
                            <v-text-field v-model="toReturn.address"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.address" @focus="responseErrors.address=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.phoneNumber || "Phone number" }}</label>
                            <v-text-field v-model="toReturn.phone_number"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.phone_number" @focus="responseErrors.phone_number=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.postalCode || "Postal Code" }}</label>
                            <v-text-field v-model="toReturn.postal_code"
                            background-color="#FFFFFF" solo outlined flat dense
                            :error-messages="responseErrors.postal_code" @focus="responseErrors.postal_code=''"></v-text-field>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.country || "Country" }}</label>
                            <v-select v-model="toReturn.country_id"
                            :items="countries" item-text="name" item-value="id"
                            background-color="#FFFFFF" solo outlined flat dense></v-select>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.currency || "Currency" }}</label>
                            <v-select v-model="toReturn.currency"
                            :items="currencies" item-text="title" item-value="value"
                            background-color="#FFFFFF" solo outlined flat dense></v-select>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.lang || "Language" }}</label>
                            <v-select v-model="toReturn.lang"
                            :items="languages" item-text="title" item-value="value"
                            background-color="#FFFFFF" solo outlined flat dense></v-select>
                        </div>
                        <div class="field-group">
                            <label>{{ $page.props.lang.unitSystem || "Unit system" }}</label>
                            <v-select v-model="toReturn.system"
                            :items="system" item-text="title" item-value="value"
                            background-color="#FFFFFF" solo outlined flat dense></v-select>
                        </div>
                </div>
                <div class="column button-wrap">
                        <v-btn @click="saveSettings" color="primary" width="160">
                            {{ $page.props.lang.save || 'Save' }}
                        </v-btn>
                    </div>
                </div>
        </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.account || "Account"
        }
    },
    props: {
        model: Object,
        countries: Array
    },
    data() {
        return {
            toReturn: this.model,
            currencies: [
                { title: 'Euro', value: 'EUR'},
                { title: 'Konvertibilna marka', value: 'BAM'},
                { title: 'Dinar', value: 'RSD'}
            ],
            languages: [
                { title: 'English', value: 'en'},
                { title: 'Srpski', value: 'sr'},
                { title: 'Bosanski', value: 'bs'},
                { title: 'Hrvatski', value: 'hr'},
            ],
            system: [
                { title: 'Metric', value: 0 },
                { title: 'Imperial', value: 1}
            ],
            responseErrors: {}
        }
    },
    methods: {
        saveSettings() {
            axios.post('/backoffice/settings/save', this.toReturn)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.$inertia.reload()
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>
